import React from 'react';
import PropTypes from 'prop-types';
import { PortalProvider } from '@gorhom/portal';
import A11yInfoProvider from '../A11yInfoProvider';
import ViewportProvider from '../ViewportProvider';
import ThemeProvider from '../ThemeProvider';
import { HydrationProvider } from './HydrationContext';

// eslint-disable-next-line no-unused-vars
import { jsx as _jsx } from "react/jsx-runtime";
const BaseProvider = /*#__PURE__*/React.forwardRef((_ref, _) => {
  let {
    defaultTheme,
    children,
    themeOptions
  } = _ref;
  return /*#__PURE__*/_jsx(HydrationProvider, {
    children: /*#__PURE__*/_jsx(A11yInfoProvider, {
      children: /*#__PURE__*/_jsx(ViewportProvider, {
        children: /*#__PURE__*/_jsx(ThemeProvider, {
          defaultTheme: defaultTheme,
          themeOptions: themeOptions,
          children: /*#__PURE__*/_jsx(PortalProvider, {
            children: children
          })
        })
      })
    })
  });
});
BaseProvider.displayName = 'BaseProvider';
BaseProvider.propTypes = {
  children: PropTypes.node.isRequired,
  defaultTheme: ThemeProvider.propTypes?.defaultTheme,
  themeOptions: PropTypes.shape({
    forceAbsoluteFontSizing: PropTypes.bool,
    forceZIndex: PropTypes.bool
  })
};
export default BaseProvider;